import React, { useCallback, useState } from 'react';

import { PrimaryButton } from '../../_core/_ui/buttons.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { IParentPlayerContact } from '../../../lib/types';
import { ParentAddContactContainer } from './parent-add-contact.container';
import { messages } from './parent-add-contact.messages';

interface IParentAddContactButtonProps {
  // Rows the picker offers; pass one player's rows to scope the dialog to it.
  contacts: IParentPlayerContact[];
  className?: string;
}

// Owns the dialog's open state so every surface that offers "add a co-contact"
// mounts one component rather than repeating the button/state/dialog trio.
export const ParentAddContactButton: React.FC<IParentAddContactButtonProps> = ({ contacts, className }) => {
  const [adding, setAdding] = useState(false);
  const closeAdding = useCallback(() => setAdding(false), []);

  return (
    <>
      <PrimaryButton className={className} variant="contained" onClick={() => setAdding(true)}>
        <IntlMsg {...messages.addContactAction} />
      </PrimaryButton>
      <ParentAddContactContainer open={adding} onClose={closeAdding} contacts={contacts} />
    </>
  );
};
